/**
 * Textes des alertes d'un job (chantier P2 « alertes produit », 2026-10-19) : éditeur, secret de
 * signature affiché une fois, derniers envois. Branchés dans `fr.ts` sous `alerts` ;
 * `alerts.en.ts` porte exactement les mêmes clés (typage + `i18n.test.ts`).
 */
export const alertsFr = {
  title: 'Alertes',
  description:
    'Prévenir quand un run démarre, réussit ou échoue : par webhook signé ou par courriel. L’alerte d’échec porte le lien vers le run.',
  add: 'Ajouter une alerte',
  addTitle: 'Nouvelle alerte',
  addDescription:
    'Un webhook reçoit l’alerte en JSON, signée par un secret propre à cette alerte ; il est affiché une seule fois, à l’enregistrement.',
  empty: 'Aucune alerte',
  emptyHelp: 'Ajoutez un webhook ou un courriel pour être prévenu de l’issue des runs.',
  remove: 'Retirer',
  removeLabel: 'Retirer l’alerte {{target}}',
  saved: 'Alertes enregistrées.',
  removed: 'Alerte retirée.',
  removeFailed: 'Alerte non retirée : réessayez.',
  columns: {
    event: 'Quand',
    type: 'Canal',
    target: 'Destination',
    signature: 'Signature',
    logTail: 'Fin du journal',
  },
  events: {
    on_start: 'Au démarrage',
    on_success: 'En cas de succès',
    on_failure: 'En cas d’échec',
  },
  types: {
    webhook: 'Webhook',
    mail: 'Courriel',
    eventhub: 'Azure Event Hub',
    other: 'Autre ({{type}})',
  },
  signed: 'Signé',
  unsigned: 'Non signé : retirez-le puis ajoutez-le pour obtenir un secret',
  logTailOn: 'Jointe',
  logTailOff: '—',
  fields: {
    event: 'Quand',
    type: 'Canal',
    url: 'URL du webhook',
    urlHelp: 'https uniquement en pratique ; jamais une adresse interne (refusée à l’envoi).',
    method: 'Méthode',
    includeLogTail: 'Joindre la fin du journal à l’alerte d’échec',
    includeLogTailHelp: 'Désactivé par défaut : un journal peut contenir des données.',
    to: 'Destinataire',
    subject: 'Objet (facultatif)',
  },
  errors: {
    url: 'URL http(s) attendue.',
    to: 'Adresse de courriel attendue.',
  },
  secret: {
    title: 'Secret de signature',
    description:
      'Copiez-le maintenant : il ne sera plus jamais affiché. Chaque alerte porte X-Graal-Signature: t=<horodatage>,v1=<HMAC-SHA256(secret, t.corps)>.',
    copy: 'Copier le secret',
    copied: 'Secret copié.',
    copyFailed: 'Copie impossible : sélectionnez le secret à la main.',
    once: 'Affiché une seule fois. Perdu : retirez l’alerte et ajoutez-la de nouveau.',
    done: 'J’ai enregistré le secret',
    verify: 'Vérification côté destinataire',
  },
  deliveries: {
    title: 'Derniers envois',
    description:
      'Conservés 30 jours (200 au plus) ; reprises comprises. Ni en-tête, ni corps, ni paramètre d’URL.',
    empty: 'Aucun envoi',
    emptyHelp: 'Les alertes envoyées apparaîtront ici, avec leur issue.',
    columns: {
      at: 'Quand',
      event: 'Événement',
      type: 'Canal',
      outcome: 'Issue',
      attempts: 'Essais',
      detail: 'Détail',
      destination: 'Destination',
      run: 'Run',
    },
    outcomes: {
      delivered: 'délivrée',
      failed: 'échec',
      blocked: 'destination refusée',
    },
    http: 'HTTP {{code}}',
  },
};
